
import ModelService from "@/service/ModelService"; 

class IndexModel extends ModelService { 
      
    constructor() {
        super();
        this.url = this.versao + '/user' ;
    }
   
   
    public getAll( ) : Promise<any> { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().get( this.url )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }
 
    public cadastrar(   dados: any ) : Promise<any> { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().post( this.url   , dados   )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }
 
    public update( id: any , dados: any ) : Promise<any>  { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().put( this.url + '/' + id   , dados  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }
 
}
  
export default IndexModel; 